var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6996 13C13.7996 11.4 12.2996 10 10.3996 9.4C11.8996 8.5 12.9996 6.9 12.9996 5C12.9996 2.2 10.7996 0 7.99959 0C5.19959 0 2.99959 2.2 2.99959 5C2.99959 6.9 4.09959 8.5 5.59959 9.4C3.69959 10 2.19959 11.3 1.29959 13C0.499592 14.3 1.49959 16 2.99959 16H12.9996C14.4996 16 15.4996 14.3 14.6996 13ZM7.99959 2C9.69959 2 10.9996 3.3 10.9996 5C10.9996 6.7 9.69959 8 7.99959 8C6.29959 8 4.99959 6.7 4.99959 5C4.99959 3.3 6.29959 2 7.99959 2ZM2.99959 14C4.09959 12 5.79959 11 7.99959 11C10.1996 11 11.8996 12 12.9996 14H2.99959Z",
    fill: "#393B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.62ecf4eba8de397bf12b82268f5767d8.svg";
export { ForwardRef as ReactComponent };